module.exports = __webpack_public_path__ + "img/sidebar-program-selector-ico-blue.b35f3408.de382109.svg";